module.exports = "../../app/cells/pages/questions/onboarding_modal_cell.rb";